<template>
<div :class="['column grid-col is-' + col_size, {'is-still': is_still}, {'exposed': exposed}, {'has-thumbnail': item.icon_type == 'Thumbnail' && item.thumb}]">
    <figure v-if="item.icon_type == 'Thumbnail' && item.thumb" class="thumb">
        <img v-if="!item.link" class="is-block" :src="item.thumb.url" :alt="item.thumb.title" />
        <template v-else>
            <router-link :to="item.link.url" v-if="item.link.is_internal" class="is-block">
                <img class="is-block" :src="item.thumb.url" :alt="item.thumb.title" />
            </router-link>
            <a :href="item.link.url" target="_blank" v-else class="is-block">
                <img class="is-block" :src="item.thumb.url" :alt="item.thumb.title" />
            </a>
        </template>
    </figure>
    <div class="inner">
        <div v-if="!item.link" class="columns is-variable is-3 is-mobile is-multiline">
            <div v-if="item.icon" class="column grid-col__icon is-narrow"><i :class="item.icon"></i></div>
            <div v-else-if="item.icon_file" class="column grid-col__icon file is-narrow"><img :src="item.icon_file" /></div>
            <div class="column has-title"><h3 v-if="item.title">{{item.title}}</h3></div>
            <div class="column is-12" v-if="item.content">
                <div :class="['content', item.title ? null : 'colour-purple']" ref="content" v-html="item.content"></div>
            </div>
        </div>
        <template v-else>
            <router-link :to="item.link.url" v-if="item.link.is_internal" class="columns is-variable is-3 is-mobile is-multiline">
                <div v-if="item.icon" class="column is-narrow"><i :class="item.icon"></i></div>
                <div v-else-if="item.icon_file" class="column grid-col__icon file is-narrow"><img :src="item.icon_file" /></div>
                <div class="column has-title"><h3 v-if="item.title">{{item.title}}</h3></div>
                <div class="column is-12" v-if="item.content">
                    <div :class="['content', item.title ? null : 'colour-purple']" ref="content" v-html="item.content"></div>
                </div>
            </router-link>
            <a :href="item.link.url" target="_blank" v-else class="columns is-variable is-3 is-mobile is-multiline">
                <div v-if="item.icon" class="column is-narrow"><i :class="item.icon"></i></div>
                <div v-else-if="item.icon_file" class="column grid-col__icon file is-narrow"><img :src="item.icon_file" /></div>
                <div class="column has-title"><h3 v-if="item.title">{{item.title}}</h3></div>
                <div class="column is-12" v-if="item.content">
                    <div :class="['content', item.title ? null : 'colour-purple']" ref="content" v-html="item.content"></div>
                </div>
            </a>
        </template>
    </div>
</div>
</template>

<script>
export default {
    name        :   'GridItem',
    props       :   ['col_size', 'item', 'is_still'],
    data()
    {
        return {
            exposed :   false
        }
    },
    created()
    {
        this.$bus.$on('onWindowScroll', this.check_exposed);
    },
    beforeDestroy()
    {
        this.$bus.$off('onWindowScroll', this.check_exposed);
    },
    mounted() {
        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        })
    },
    methods     :   {
        check_exposed(offset)
        {
            if ($(this.$el).offset().top + $(this.$el).outerHeight() * 0.3 < offset + $(window).height()) {
                this.exposed    =   true;
                this.$bus.$off('onWindowScroll', this.check_exposed);
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/elements/GridItem.vue